module.exports = __webpack_public_path__ + "assets/images/project/constituencies/pasir-ris-punggol-grc.jpg?v=c2f2d5fd";